<template>
    <div>
        <div
            class="cursor-pointer"
            v-if="category.containsSegments"
            @click="openCategory(category.name)">
            <strong class="segment-category inline-s">{{category.label}}</strong>
            <v-icon icon="caret-right" :class="{'is-rotating-right': segmentCollection.activePage.isCategoryActive(category.name)}"/>
        </div>
        <template v-if="segmentCollection.activePage.isCategoryActive(category.name)">
            <ul class="list list-group list-compact margin-top-s">
                <li
                    class="list-item"
                    v-for="segment in category.visibleSegments"
                    :key="segment.$internalId">
                    <segment-link :segment="segment"/>
                </li>
                <li v-if="category.containsHiddenSegments"
                    class="list-item no-flex margin-top-s">
                    <r-button
                        class="no-flex margin-left-m"
                        type="link"
                        @click="toggleHiddenSegments">
                        <span v-if="category.showHidden">Hide</span>
                        <span v-else>Show {{category.hiddenSegments.length}} hidden</span>
                    </r-button>
                </li>
            </ul>
            <template v-if="category.showHidden">
                <segment-search/>
                <ul class="list list-group margin-top-s">
                    <li
                        class="list-item"
                        v-for="segment in category.hiddenSegments"
                        :key="segment.id">
                        <segment-link :segment="segment"/>
                    </li>
                </ul>
            </template>
        </template>
    </div>
</template>

<script>
    import {vIcon} from '@/components/form';
    import SegmentLink from '@/modules/segments/components/segment-link';
    import SegmentSearch from '@/modules/segments/components/segment-search';
    import {mapActions} from 'vuex';

    export default {
        name: 'segment-column-category',
        components: {
            vIcon, SegmentSearch, SegmentLink,
        },
        props: {
            category: Object,
            segmentCollection: Object,
            activeSegment: Object,
        },
        methods: {
            ...mapActions({
                setActiveSegmentId: 'segments/setActiveSegmentId',
                toggleHiddenSegments: 'segments/toggleHiddenSegments',
                activateSegmentCategory: 'segments/activateSegmentCategory',
                updateActiveFilters: 'segments/updateActiveFilters',
                fetchSegmentsCount: 'segments/fetchSegmentsCount',
            }),
            openCategory(categoryName) {
                this.activateSegmentCategory(categoryName);
                this.updateActiveFilters(this.activeSegment.data.filters);
            },
        },
    };
</script>

<style scoped>

</style>
